import { CapaDaNotaServiceAdapter } from '@/usecases'
import request from '@/common/request';
import { CapaDaNota, CapaDaNotaParaCartaDeCorrecao, FiltroDeCapaDaNota, NotaFiscalCompleta, Page } from '@/models';
import { AxiosRequestConfig } from 'axios';
import { getXmlsCompletos } from '@/api/notasFiscais'

const BASE_URL = '/notas-fiscais'
export class CapaDaNotaService implements CapaDaNotaServiceAdapter {
	find = async (params?: FiltroDeCapaDaNota, config?: AxiosRequestConfig): Promise<Page<CapaDaNota>> =>
		request.get(`${BASE_URL}`, {
			params,
			...config,
		})

	getXmlsCompletos = async (params: FiltroDeCapaDaNota): Promise<string[]> => getXmlsCompletos(params)

	findByChNFe = async (chNFe: string): Promise<CapaDaNotaParaCartaDeCorrecao> =>
		request.get(`${BASE_URL}/${chNFe}`)

	findBySerieAndNnf = async (params: any, lojaId: string): Promise<CapaDaNotaParaCartaDeCorrecao> =>
		request.get(`${BASE_URL}/${lojaId}/buscarCapaDaNota`, {
			params,
		})

	findNotasParaDevolucao = async (params?: any): Promise<Page<CapaDaNota>> =>
		request.get(`${BASE_URL}/devolucao`, {
			params,
		})

	getDetalhes = async (notaId: string): Promise<NotaFiscalCompleta> =>
		request.get(`${BASE_URL}/${notaId}/detalhar`)

	findIdDestByChave = async (chaveDaNota: string[], config?: AxiosRequestConfig): Promise<boolean> =>
		request.get(`${BASE_URL}/busca-id-dest`, {
			params: { chaveDaNota },
			responseType: 'arraybuffer',
			...config,
		});

}
